<div class="search-widget-v4-mobile-suggestions">
  @if (whichIsFocused() === SearchWidgetFreeSearchFieldsEnum.FREESEARCH) {
    @if (freeSearchPopularSuggestItems()) {
      <div
        class="search-widget-v4-mobile-suggestions-label text-xs font-medium uppercase"
      >populära kategorier
      </div
      >
      <div class="flex flex-wrap content-start justify-start gap-4 pt-3">
        @for (popularItem of freeSearchPopularSuggestItems(); let i = $index; track popularItem.id) {
          <app-ui-button
            (onClick)="onFreeSearchPopularOptionClick(popularItem)"
            [color]="'tertiary'"
            [expanded]="'pill'"
            [id]="(i + 1).toString() + '-suggestion-popular-suggestions-option'"
            [ngClass]="'test-search-autocomplete-item-' + (i + 1)"
            [queryParams]="popularItem.queryParams"
            [routerLink]="popularItem.routerLink"
            [size]="'sm'"
            tabindex="null"
          >
            {{ popularItem.name }}
          </app-ui-button>
        }
      </div>
    }


    @if (freeSearchFilteredSuggestItems()) {
      <div class="search-widget-v4-mobile-suggestions-label">Förslag</div>
      @for (suggestItem of freeSearchFilteredSuggestItems(); let i = $index; track suggestItem.suggestValue) {
        <div
          (click)="onFreeSearchOptionClick(i, suggestItem.suggestValue)"
          [id]="'freesearch-suggestion-query-' + i"
          [ngClass]="'test-search-autocomplete-option-' + i"
          class="search-widget-v4-mobile-suggestions-option"
        >
          <div class="suggest-item-wrap">
            <span
              [ngClass]="'test-search-autocomplete-item-' + i"
              class="suggest-item"
            >{{ suggestItem.suggestValue }}
            </span>
            <small
              [ngClass]="'test-search-autocomplete-item-annotation-' + i"
              class="suggest-item-annotation"
            >{{ suggestItem.suggestLabel }}
            </small>
          </div>
          <app-ui-icon
            color="var(--green-2)"
            name="chevron_right"
            size="sm"
          ></app-ui-icon>
        </div>
      }
    }
  }

  @if (whichIsFocused() === SearchWidgetFreeSearchFieldsEnum.PLACE) {
    @if (placePopularSuggestItems()) {
      <div
        class="search-widget-v4-mobile-suggestions-label text-xs font-medium uppercase"
      >populära platser
      </div
      >
      <div class="flex flex-wrap content-start justify-start gap-4 pt-3">
        @if (state().isLocationSearchVisible) {
          <app-ui-button
            (onClick)="searchByLocationClick()"
            [color]="'tertiary'"
            [expanded]="'pill'"
            [id]="'place-suggestion-popular-nara'"
            [ngClass]="'test-search-autocomplete-place-option-nara-0'"
            [size]="'sm'"
            tabindex="null"
          >
            {{ SearchWidgetLabelsEnum.NARA_MIG }}
          </app-ui-button>
        }

        @for (popularItem of placePopularSuggestItems(); let i = $index; track popularItem.id) {
          <app-ui-button
            (onClick)="onPlaceOptionClick(popularItem.name)"
            [color]="'tertiary'"
            [expanded]="'pill'"
            [id]="'place-suggestion-popular-' + (i + 1)"
            [ngClass]="'test-search-autocomplete-place-option-' + (i + 1)"
            [queryParams]="popularItem.queryParams"
            [routerLink]="popularItem.routerLink"
            [size]="'sm'"
            tabindex="null"
          >
            {{ popularItem.name }}
          </app-ui-button>
        }
      </div>
    }

    @if (placeFilteredSuggestItems()) {
      <div class="search-widget-v4-mobile-suggestions-label">Förslag</div>
      @for (suggestItem of placeFilteredSuggestItems(); let i = $index; track suggestItem.suggestValue) {
        <div
          (click)="onPlaceOptionClick(suggestItem.suggestValue)"
          [id]="'place-suggestion-query-' + i"
          [ngClass]="'test-search-autocomplete-place-option-' + i"
          class="search-widget-v4-mobile-suggestions-option"
        >
          <div>
            <span
              [ngClass]="'test-search-autocomplete-place-item-' + i"
              class="suggest-item"
            >{{ suggestItem.suggestValue }}
            </span>
            <small
              [ngClass]="'test-search-autocomplete-item-place-annotation-' + i"
              class="suggest-item-annotation"
            >{{ suggestItem.suggestLabel }}
            </small>
          </div>
          <app-ui-icon
            color="var(--green-2)"
            name="chevron_right"
            size="sm"
          ></app-ui-icon>
        </div>
      }
    }
  }
</div>
